import {_} from 'lodash';
import * as ko from "knockout";
import {ErrorObject} from "./ErrorObject";
import {getNextId} from "../util/misc";
import {lm} from "../appContext";

export class ErrorManager {
    private errorObjects: KnockoutObservableArray<ErrorObject> = ko.observableArray<ErrorObject>([]);
    private id: number = getNextId();

    getNumErrors(): number {
        return this.errorObjects().reduce((num: number, obj: ErrorObject) => num + Number(!obj.validate()), 0);
    }

    _getNumErrors = ko.pureComputed((): number => this.getNumErrors())

    getErrorMessages(): string[] {
        return this.errorObjects().filter(o => !o.validate()).map(o => o.getErrorMessage());
    }

    getErrorMessagesString(): string {
        const errorMessages = this.getErrorMessages();
        const errors = _.groupBy(errorMessages);
        const messages = Object.keys(errors).map(key => `${lm.t(key)} (${errors[key].length})`);
        const numErrors = errorMessages.length
        return lm.t(`${numErrors} ((form|ac)) ((error|ac|n:${numErrors})):\n`) + messages.map(s => '- ' + s).join('\n')
    }

    addErrorObject(obj: ErrorObject) {
        this.errorObjects.push(obj);
    }

    removeErrorObject(obj: ErrorObject) {
        this.errorObjects.remove(obj);
    }

    validate = ko.pureComputed((): boolean => {
        return this.errorObjects().reduce((bool: boolean, obj: ErrorObject) => obj.validate() && bool, true);
    })

    getErrorObjectByName(name: string): ErrorObject | undefined {
        return this.errorObjects().find(o => o.name == name);
    }

    discard() {
        this.errorObjects().forEach(o => o.dispose())
        this.errorObjects([]);
        this.validate.dispose()
    }
}

